{
  "page": { "title": "Inbound report", "subtitle": "{{count}} documents in range" },
  "column": {
    "doc_no": "Doc no",
    "doc_type": "Type",
    "load_date": "Date",
    "load_time": "Time",
    "sku": "SKU",
    "quantity": "Quantity",
    "tran_type": "Direction",
    "remark": "Remark",
    "ref_no": "Reference"
  },
  "direction": { "IN": "In", "OUT": "Out" },
  "kpi": {
    "docs_in_range": "Docs in range",
    "total_received": "Total qty received",
    "last_inbound": "Last inbound"
  },
  "toolbar": {
    "search_placeholder": "Search doc, SKU or reference…",
    "export": "Export",
    "date_from": "From",
    "date_to": "To"
  },
  "state": {
    "empty": "No inbound documents in this range.",
    "error": "Could not load the inbound report.",
    "none": "—"
  }
}
